
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campuses",
      function () {
        return require("private-next-pages/campuses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campuses"])
      });
    }
  